import React from 'react';
import ProductLink from '../models/ProductLink';
import ProductLinkCard from './ProductLinkCard';

interface BuyingGuideProps {
  productLinks: ProductLink[];
}

export default class BuyingGuide extends React.PureComponent<BuyingGuideProps> {
  render() {
    return (
      <div className="buying-guide">
        {this.props.productLinks.map(productLink => (
          <ProductLinkCard key={productLink.slug} productLink={productLink} showDescription={true} />
        ))}
      </div>
    );
  }
}
